import { render, staticRenderFns } from "./property-setting-list-table.vue?vue&type=template&id=a9eb15f8&"
import script from "./property-setting-list-table.vue?vue&type=script&lang=js&"
export * from "./property-setting-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports